export default function TeacherMainPage() {
    return (
        <div>
            <div>Welcome to the Teacher Main Page</div>
        </div>
    );
}